<section id="terminos">


  <div class="container">
    <div class="row justify-content-center">
      <div class="col col-md-12 col-12" >
        <h2>POLÍTICA DE PRIVACIDAD Y DE PROTECCIÓN DE DATOS PERSONALES DE MUNDO-FINANCIERA SAS</h2>
        <div class="container" style="    width: 100% !important;
        max-width: 100% important;">
          <div class="row" style="  width: 100% !important;
          max-width: 100% important;">
            <div class="col-md-12">
              <h2 class="wow fadeInUp" style="font-size: 22px !important;">Confirme sus datos</h2>
            </div>
            <div class="col-md-12">
              <form class="consulta" id="formulario">
                <div class="form-group cl-white">
                  <label for="p1">{{ tipoDocumento === "1" ? 'Número Documento' : 'NIT' }}</label>
                  <input type="text" [(ngModel)]="numeroIdentificacion" [ngModelOptions]="{standalone: true}" readonly class="form-control">
                </div>

                <div class="form-group cl-white" *ngIf="tipoDocumento == '3'">
                  <label for="p1">Razón Social</label>
                  <input type="text" [(ngModel)]="razonSocial" [ngModelOptions]="{standalone: true}"readonly class="form-control">
                </div>

                <div class="form-group cl-white">
                  <label for="p1">Celular</label>
                  <input type="text" [(ngModel)]="celular" [ngModelOptions]="{standalone: true}"readonly class="form-control">
                </div>

                <div class="form-group cl-white" *ngIf="tipoDocumento == '3'">
                  <label for="p1RL">Número Documento Representante Legal</label>
                  <input  type="text" [(ngModel)]="numeroIdentificacionRL" [ngModelOptions]="{standalone: true}" readonly class="form-control" placeholder="Número Documento">
                </div>
                <div class="form-group cl-white">
                  <label for="p1">Primer Nombre</label>
                  <input  type="text" [(ngModel)]="primerNombre" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Primer Nombre">
                </div>
                <div class="form-group cl-white">
                  <label for="p2">Segundo Nombre</label>
                  <input type="text" [(ngModel)]="segundoNombre" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Segundo Nombre">
                </div>
                <div class="form-group cl-white">
                  <label for="p3">Primer Apellido</label>
                  <input  type="text" [(ngModel)]="primerApellido" [ngModelOptions]="{standalone: true}"class="form-control" placeholder="Primer Apellido">
                </div>
                <div class="form-group cl-white" >
                  <label for="p4">Segundo Apellido</label>
                  <input type="text" [(ngModel)]="segundoApellido" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Segundo Apellido">
                </div>

                <div class="form-group cl-white" style="display: none;">
                  <label for="p1">Codigo Transacción</label>
                  <input type="text" [(ngModel)]="codigoTransaccion" [ngModelOptions]="{standalone: true}" readonly class="form-control">
                </div>

                <p style="    font-family: 'Hind', sans-serif;
                color: #41464b;
                font-size: 15px;
                font-weight: 300;"> Al dar clic al botón acepto el tratamiento de mis datos personales de
                  acuerdo a la presente
                  autorización, en cumplimiento de la Ley 1266 de 2008 y Ley 1581 de 2012 de Protección de Datos, en mi
                  nombre
                  y/o en mi calidad de representante legal de la persona jurídica aquí mencionada, autorizamos de manera
                  libre,
                  previa, expresa e informada a MUNDO FINANCIERA SAS, entidad identificada con NIT 901366485-8 con
                  domicilio en
                  la Calle 13a No 100 - 35, Cali, Valle del Cauca, Colombia. PBX +602-3928850, y a las centrales de
                  riesgo
                  financiero con las que se tenga vínculo comercial, en calidad de RESPONSABLES DEL TRATAMIENTO DE DATOS
                  PERSONALES, para que recolecte, capture, almacene, organice, depure, use, circule, suprima, disocie,
                  procese,
                  consulte, suministre, actualice, analice, reporte, divulgue, retire, trasmita y transfiera a terceros
                  dentro y
                  fuera del territorio nacional y en general realice tratamiento sobre los datos personales entregados
                  al
                  diligenciar la presente solicitud con el fin de: 1) Dar trámite a la solicitud que se presenta; 2)
                  Consultar,
                  verificar y analizar la información consignada en los formularios diligenciados, así como la que se
                  encuentra
                  dentro de los documentos que se lleguen a adjuntar, ante centrales de riesgo, fuentes privadas y
                  fuentes
                  públicas, así como realizar procesos de validación de identidad y medición de riesgo de iniciar o
                  mantener
                  relaciones comerciales con el solicitante; 3) Contactarse con el titular de la información, o los
                  empleados de
                  la empresa que represento, y/o codeudor, deudor solidario y/o avalista para brindar información o
                  gestionar el
                  cobro de obligaciones financieras adquiridas por parte de EL CLIENTE con MUNDO FINANCIERA SAS y todas
                  las
                  entidades que adelantan gestiones de cobranza de forma directa, por medio de terceros o por cesión de
                  la
                  obligación, a través de los siguientes canales y de conformidad con las políticas establecidas por
                  MUNDO
                  FINANCIERA SAS, las cuales declaro conocer y aceptar: i) línea de teléfono fijo; ii) línea de teléfono
                  móvil;
                  iii) correo electrónico; iv) mensajes de texto (SMS); v) aplicaciones de mensajería instantánea como
                  WhatsApp
                  o cualquier otra aplicación; vi) correo postal; vii) visita domiciliaria y/o al lugar de trabajo, de
                  acuerdo a
                  lo preceptuado en la Ley; viii) cualquier otro medio de comunicación digital asociado al número de
                  teléfono y
                  correo del deudor y/o codeudor; 4) Comunicarse y enviar información comercial, de mercadeo y
                  promocional
                  relacionada con los servicios y productos ofrecidos por la entidad a través de cualquier medio físico
                  o
                  electrónico, conocido o por conocerse, dentro de los cuales se incluyen los siguientes canales y de
                  conformidad con las políticas establecidas por MUNDO FINANCIERA SAS, las cuales declaro conocer y
                  aceptar: i)
                  línea de teléfono fijo; ii) línea de teléfono móvil; iii) correo electrónico; iv) mensajes de texto
                  (SMS); v)
                  aplicaciones de mensajería instantánea como WhatsApp o cualquier otra aplicación; vi) correo postal;
                  vii)
                  visita domiciliaria y/o al lugar de trabajo, de acuerdo a lo preceptuado en la Ley; viii) cualquier
                  otro medio
                  de comunicación digital asociado al número de teléfono y correo del deudor y/o codeudor; 5) Atender y
                  tramitar
                  peticiones, quejas y reclamos; 6) Registrarlo como cliente de MUNDO FINANCIERA SAS, 7). Analizar el
                  riesgo
                  financiero de EL CLIENTE, 8). Mantener actualizados sus datos en los sistemas de información de MUNDO
                  FINANCIERA SAS, 9). Dar cumplimiento y seguimiento a las obligaciones contraídas por EL CLIENTE con
                  MUNDO
                  FINANCIERA SAS, 10). Proveer, procesar, completar y darle seguimiento a los productos y servicios
                  financieros
                  por usted adquiridos, 11). Realizar análisis estadísticos, de tendencias y comportamientos del
                  mercado, 12).
                  Comunicar a través de correo físico y/o electrónico o de cualquier otro medio de comunicación
                  electrónica
                  equivalente conocida o por conocerse información relativa a los estados de cuenta de los productos y
                  servicios
                  financieros adquiridos a MUNDO FINANCIERA SAS, así como de asuntos contables y de facturación. 13)
                  Acceder a
                  mis datos personales y/o de la entidad a la que represento reportados por los empleadores y/o
                  pensionados y/o
                  por mi condición de trabajador al Sistema de Seguridad Social y Parafiscales de Colombia, los cuales
                  se
                  encuentran contenidos en bases de datos de operadores de información de seguridad social autorizados
                  por el
                  Ministerio de Salud y Protección social o administradoras de pensiones, a mis datos personales y/o de
                  la
                  entidad a la que represento recolectados por cualquier medio para la adquisición de bienes y/o
                  servicios, y a
                  mi información financiera, crediticia, comercial y/o de servicios contenida en la base de datos que
                  administran las centrales de riesgo financiero como operadores de información, para finalidades de
                  gestión de
                  riesgo financiero y crediticio tales como: i) elaboración, valoración y circulación de scores
                  crediticios;
                  (ii) elaboración, valoración y circulación de herramientas de validación y predicción de ingresos;
                  (iii)
                  acceso y uso de herramientas e índices de variación de mis ingresos calculados con mis datos
                  personales
                  mencionados con antelación, con mis datos asociados a mi ubicación y condiciones macroeconómicas de
                  ubicación,
                  como el PIB y proveniente del Departamento Administrativo Nacional de Estadística (DANE), y
                  adicionalmente
                  calculados con mis datos que reposan en el SISBEN, los cuales determinan si tengo mayor o menos
                  capacidad para
                  generar ingresos, como los son los datos de naturaleza pública asociados al grupo y nivel al que
                  pertenezco en
                  el SISBEN; (iv) herramientas para evitar el fraude; (v) en general herramientas que permitan adelantar
                  una
                  adecuada gestión del riesgo financiero y crediticio; y (vi) compararla, contrastarla y complementarla
                  con la
                  información financiera, comercial, crediticio, de servicio y proveniente de terceros países. En caso
                  de que,
                  en el futuro, el autorizado en este documento efectúe una venta de cartera o cesión a cualquier título
                  de las
                  obligaciones a cargo del titular de los datos, a favor de un tercero, los efectos de la presente
                  autorización
                  se extenderán a éste, en los mismos términos y condiciones expresadas en este consentimiento. Para
                  efectos de
                  actividades de cobranza y notificaciones, incluyendo las notificaciones previas a los reportes
                  negativos a las
                  centrales de riesgo autorizo a MUNDO FINANCIERA SAS para comunicarse a través de cualquier medio
                  físico
                  electrónico o virtual, incluyendo, sin limitarse a ellos, i) línea de teléfono fijo; ii) línea de
                  teléfono
                  móvil; iii) correo electrónico; iv) mensajes de texto (SMS); v) aplicaciones de mensajería instantánea
                  como
                  WhatsApp o cualquier otra aplicación; vi) correo postal; vii) visita domiciliaria y/o al lugar de
                  trabajo, de
                  acuerdo a lo preceptuado en la Ley; viii) cualquier otro medio de comunicación digital asociado al
                  número de
                  teléfono y correo del deudor y/o codeudor. Igualmente autorizo para que, con fines de verificación,
                  actualización de datos y localización se contacte, ya sea el momento del estudio para la aprobación
                  del
                  crédito solicitado o en cualquier momento, bajo las limitaciones previstas en la Ley, mientras sea
                  deudor del
                  crédito desembolsado a las referencias presentadas, de las cuales manifiesto contar con todas las
                  autorizaciones para el efecto y, en caso de que haya lugar, descontar el valor de la consulta hecha a
                  las
                  centrales de riesgo. En todo caso, el tratamiento de los datos personales compartidos, estará sujeto a
                  lo
                  establecido en la Ley 1581 de 2012, sus decretos reglamentarios, y las normas que la/los modifiquen,
                  así como
                  a las políticas de tratamiento de datos personales publicadas en la página web
                  https://www.mundofinanciera.com/#/terminos-condiciones, la cual contiene los derechos, lineamientos,
                  directrices y procedimientos sobre el tratamiento de la información de los titulares, y la forma de
                  hacer
                  efectivos sus derechos de conocer, verificar, corregir, actualizar, solicitar prueba de la
                  autorización
                  otorgada, así como solicitar la eliminación de cualquier dato personal entregado, siempre y cuando no
                  exista
                  una obligación de tipo legal o contractual que impida su eliminación de la base de datos. Los derechos
                  podrán
                  ser ejercidos a través de comunicación física dirigida a la Calle 13a No 100 - 35, Cali, Valle del
                  Cauca,
                  Colombia, o mediante comunicación electrónica a la siguiente cuenta de correo electrónico:
                  servicioalcliente@mundofinanciera.com , indicando en el asunto “habeas data” nombre completo y
                  documento de
                  identificación del solicitante.</p>



                <br />
                <button class="btn btn-general btn-white"  type="submit"  role="button" (click)="confirmarAutorizacionDatos()">
                  <i fa fa-right-arrow></i>Aceptar
                </button>
              </form>
            </div>


          </div>
        </div>


      </div>
    </div>
  </div>
</section>
